import { CONMAN_DATA } from "../conmanData";
import { BRAND_KEY, DEFAULT_BRAND_KEY, HOST_TO_BRAND_KEY_MAP } from "./constants";

export const getBrandKeyFromHost = (host) => {
  const brandKey = HOST_TO_BRAND_KEY_MAP[host];
  return brandKey || DEFAULT_BRAND_KEY;
}

export const getBrandKey = () => {
  if (window) {
    return getBrandKeyFromHost(window.location.hostname);
  }
  return BRAND_KEY.URBAN_COMPANY;
}

export const getBrandConfig = () => {
  const brandKey = getBrandKey();
  return (CONMAN_DATA.brandConfig || []).find(brand => brand.key === brandKey);
};
